<template>
    <content-view>
        <div slot="header">
            <a-form :form="form" layout="inline" class="store-one-form">
                <a-form-item label="用户票券号">
                    <a-input placeholder="请输入" v-decorator="['userTicketId']"></a-input>
                </a-form-item>
                <a-form-item label="会员手机号">
                    <a-input placeholder="请输入" v-decorator="['phone']"></a-input>
                </a-form-item>
                <a-form-item label="单次核销金额">
                    <a-input-group compact >
                        <a-input-number :precision="0" class="range-input range-input-left" placeholder="请输入" v-decorator="['singleVerifyMin']" />
                        <a-input style="width: 40px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled />
                        <a-input-number :precision="0" class="range-input range-input-right" placeholder="请输入" v-decorator="['singleVerifyMax']" />
                    </a-input-group>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="container">
            <section class="flex flex-space-between flex-align-start">
                <div class="mb16 mr16 flex flex-start flex-wrap" v-if="shopType == -2">
                    <span class="mr24">票券名称: {{ticketDetail.ticketName}}</span>
                    <span class="mr24">查询时间段: {{dateLine}}</span>
                    <span class="mr24">购买门店: {{ticketDetail.buyShop}}</span>
                    <span class="mr24">跨店核销总次数: {{ticketDetail.crossTotalCount || 0}} </span>
                    <span class="mr24">跨店核销金额总计：{{ticketDetail.crossTotalAmount | amountFormat}}</span>
                </div>
                <div class="mb16 mr16 flex flex-start flex-wrap" v-else>
                    <span class="mr24">票券名称: {{ticketDetail.ticketName}}</span>
                    <span class="mr24">查询时间段: {{dateLine}}</span>
                    <span class="mr24">核销门店：{{ticketDetail.verifyShop}}</span>
                    <span class="mr24">核销总次数：{{ticketDetail.crossTotalCount || 0}} </span>
                    <span class="mr24">核销金额总计：{{ticketDetail.crossTotalAmount | amountFormat}}</span>
                </div>
                <a-button type="primary" @click="exportTicketDetail">导出</a-button>
            </section>
            <a-table
                :bordered="true"
                :dataSource="dataSource"
                :columns="columns"
                :scroll="{ x: 800 }" 
                :pagination="pagination"
                @change="changePage"
                :rowKey="(record,index) => index"
                style="word-break:break-all"
            >
                <span slot="singleVerifyAmount" slot-scope="amount, a,b">{{amount|amountFormat}}</span>
                <span slot="totalAmount" slot-scope="amount, a,b">{{amount|amountFormat}}</span>
            </a-table>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    const columns = [
        {
            title: "日期",
            dataIndex: "consumeTime"
        },
        {
            title: "用户票券号",
            dataIndex: "userTicketId"
        },
        {
            title: "消费流水号",
            dataIndex: "userTicketConsumeId"
        },
        {
            title: "实际核销票券名称",
            dataIndex: "ticketPrivilegeName"
        },
        {
            title: "用户手机号",
            dataIndex: "ownerPhone",
            scopedSlots: { customRender: "ownerPhone" }
        },
        {
            title: "当日单次核销金额",
            dataIndex: "thisVerifyAmount",
            scopedSlots: { customRender: "thisVerifyAmount" }
        },
        {
            title: "核销次数",
            dataIndex: "verifyNum",
            scopedSlots: { customRender: "verifyNum" }
        },
        {
            title: "核销人",
            dataIndex: "verifyCashier"
        },
        {
            title: "合计",
            dataIndex: "multiplyVerifyAmount",
            scopedSlots: { customRender: "multiplyVerifyAmount" }
        },
    ];
    const columns2 = [
        {
            title: "日期",
            dataIndex: "date"
        },
        {
            title: "用户票券号",
            dataIndex: "userTicketNumber"
        },
        {
            title: "消费流水号",
            dataIndex: "consumeSerial"
        },
        {
            title: "实际核销票券名称",
            dataIndex: "actualVerifyTicketName"
        },
        {
            title: "用户手机号",
            dataIndex: "userPhone",
            scopedSlots: { customRender: "userPhone" }
        },
        {
            title: "当日单次核销金额",
            dataIndex: "singleVerifyAmount",
            scopedSlots: { customRender: "singleVerifyAmount" }
        },
        {
            title: "核销次数",
            dataIndex: "verifyCount",
            scopedSlots: { customRender: "verifyCount" }
        },
        {
            title: "核销人",
            dataIndex: "verifyMan"
        },
        {
                title: "核销门店",
                dataIndex: "verifyShop",
        },
        {
            title: "合计",
            dataIndex: "totalAmount",
            scopedSlots: { customRender: "totalAmount" }
        },
    ];
export default {
    name: "ticketCountDetail",
    props: {},
    data() {
        return {
            dataSource: [],
            columns,
            // 分页
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                total: 0,
                showSizeChanger: true,
                showQuickJumper: true,
                current: 1,
                pageSize: 20
            },
            date: [],
            ticketDetail: {},
            ticketId: 0,
            shopId: 0,
            shopType: 0,
            name: '',
            lineType: 0,
        };
    },
    computed: {
        dateLine() {
            return this.date.join('~');
        },
    },
    filters: {
        amountFormat(val) {
            if (!val) {
                return "0.00"
            } else {
                return val.toFixed(2);
            }
        }
    },
    methods: {
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            if (this.$route.query.type == -2) {
                // 跨店门店
                this.columns = columns2;
                this.VerifyDetail();
            } else {
                // 票券核销
                this.columns = columns;
                this.getList();
            }
        },
        handleReset () {
            this.form.resetFields();
        },
        search() {
            this.pagination.current = 1;
            if (this.$route.query.type == -2) {
                // 跨店门店
                this.columns = columns2;
                this.VerifyDetail();
            } else {
                // 票券核销
                this.columns = columns;
                this.getList();
            }
        },
        getList() {
            this.form.validateFields((errors,values) => {
                if (errors) return;
                for (const i in values) {
                    if (values.hasOwnProperty(i) && values[i]) {
                        values[i] = values[i].toString().trim();
                    }
                }
                this.$api.statement.ticketVerifyDetailStatistics({
                    body: {
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                        ...values,
                        startDate: this.date[0].trim(),
                        endDate: this.date[1].trim(),
                        ticketId: this.ticketId,
                        shopId: this.shopId,
                        lineType: this.lineType,
                    }
                }).then( res => {
                    this.pagination.total = res.total;
                    this.dataSource = res.data;
                    this.ticketDetail = res.extraData;
                })
            });
        },
        //跨店核销
        VerifyDetail() {
            this.form.validateFields((errors,values) => {
                if (errors) return;
                let params = {
                    maxAmount: values.singleVerifyMax,
                    minAmount: values.singleVerifyMin,
                    ticketId: this.ticketId,
                    userPhone: values.phone,
                    lineType: this.lineType,
                    userTicketNumber: values.userTicketId,
                    buyShopId: this.shopId,
                }
                this.$api.statement.VerifyDetail({
                    body: {
                        ...params,
                        startDate: this.date[0].trim(),
                        endDate: this.date[1].trim(),
                    }
                }).then( res => {
                    this.pagination.total = res.data.length;
                    this.dataSource = res.data;
                    this.ticketDetail = res;
                    this.ticketDetail.crossTotalAmount.toFixed(2);
                })
            });
        },
        //导出
        exportTicketDetail() {
            this.exportLoading = true;
            this.form.validateFields((errors,values) => {
                if (errors) return;
                if(this.shopType == -2) {
                    //跨店
                    var DetailExcel = this.$api.statement.crossVerifyDetailExcel({
                        body: {
                            maxAmount: values.singleVerifyMax,
                            minAmount: values.singleVerifyMin,
                            ticketId: this.ticketId,
                            userPhone: values.phone,
                            userTicketNumber: values.userTicketId,
                            buyShopId: this.shopId,
                            startDate: this.date[0].trim(),
                            endDate: this.date[1].trim(),
                        }
                    }, {responseType: "blob"})
                } else {
                    //核销
                    var DetailExcel = this.$api.statement.exportSomeDetail({
                        body: {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            ...values,
                            startDate: this.date[0].trim(),
                            endDate: this.date[1].trim(),
                            ticketId: this.ticketId,
                            shopId: this.shopId,
                            lineType: this.lineType,
                        }
                    }, {responseType: "blob"})
                }
                DetailExcel.then( res => {
                    let a = document.createElement("a");
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    this.downloadUrl = window.URL.createObjectURL(blob);
                    this.name = this.ticketDetail.ticketName;
                    let name = this.name + '-' + this.$moment().format('YYYY/MM/DD') + '.xls'

                    a.setAttribute("href", this.downloadUrl);

                    var reportName = decodeURI(name);

                    a.setAttribute("download", reportName);
                    a.click();
                    this.exportLoading = false
                });
            });
        }
    },
    created() {
        this.form = this.$form.createForm(this);
    },
    mounted() {
        if (this.$route.query.dateLine) {
            this.date = this.$route.query.dateLine.split("~");
        }
        this.ticketId = this.$route.query.id;
        this.shopId = this.$route.query.shopId;
        this.lineType = this.$route.query.lineType;
        this.shopType = this.$route.query.type;
        if (this.$route.query.type == -2) {
            // 跨店门店
            this.columns = columns2;
            this.VerifyDetail();
        } else {
            // 票券核销
            this.columns = columns;
            this.getList();
        }
    }
}
</script>
<style lang="scss">
.container {
    background: #fff;
}
</style>